import { AuthResponseStatus } from '@/enums/AuthResponseStatus';
import Service from '@/models/Service';
import Response from '@/models/Response';

export default class ServiceResponse extends Response {
  public services: Service[] = new Array<Service>();

  constructor(status: AuthResponseStatus, services: Service[], accessToken: string, messageEN = '', messageNL = '') {
    super(status, accessToken, messageEN, messageNL);
    this.services = services;
  }

  public static buildSuccesResponse(services: Service[], accessToken: string): ServiceResponse {
    return new ServiceResponse(AuthResponseStatus.SUCCESS, services, accessToken);
  }

  public static buildFailedResponse(messageEN: string, messageNL: string): ServiceResponse {
    return new ServiceResponse(AuthResponseStatus.FAILED, [], '', messageEN, messageNL);
  }
}
